import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../store'
import { HashRouter,Route, Switch, Redirect } from 'react-router-dom';
import _ from 'lodash';

import { AzureAD, LoginType, AuthenticationState } from 'react-aad-msal';
// Import the provider created in a different file
import { authProvider } from '../utils/authProvider';

import 'bootstrap/dist/css/bootstrap.css';
import PrivateLayout from './private';
import PublicLayout from './public';
import SessionLayout from './session';

import privateRoutes from './routes/privateRoutes';
import publicRoutes from './routes/publicRoutes';
import sessionRoutes from './routes/sessionRoutes';

import { verify as verifyAction, login as loginAction, logout as logoutAction } from '../store/user/UserActions';
import { IUser } from '../store/interface';
//import Login from '../pages/user/Login';
import NotFound from './public/NotFound';
// @ts-ignore 
import { basicReduxStore } from "../store/user/msalReducer";
import { Spinner } from 'reactstrap';
import ForgotPassword from './public/ForgotPassword';
import { Home } from '../PublicComponents';
import RedirectHome from './public/RedirectHome';

interface PropsFromState {
    // userDB: IUser
    userDB: any

}
interface IState {
    loginVerify: boolean
}
// We can use `typeof` here to map our dispatch types to the props, like so.
interface PropsFromDispatch {
    verify: typeof verifyAction
    logout: typeof logoutAction
    login: typeof loginAction
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch



class Template extends Component<AllProps, IState> {
    loginVerify: boolean = false;
    /**
     *
     */
    constructor(props: AllProps) {
        super(props);
        this.state = {
            loginVerify: false
        };
        const authProviderOptions = authProvider.getProviderOptions();
        authProviderOptions.loginType = LoginType.Redirect;
        authProvider.setProviderOptions(authProviderOptions);
    }
    componentDidMount() {
    }
    componentWillMount() {
    }
    componentDidUpdate(prevProps: AllProps) {
    }

    editProfile() {
        authProvider.authority = "https://ultimatesprodev.b2clogin.com/ultimatesprodev.onmicrosoft.com/B2C_1A_signup_signin";
        authProvider.loginRedirect();
    }

    render() {
        return (
            <AzureAD provider={authProvider} reduxStore={basicReduxStore} forceLogin={true} >
                {
                    ({ login, logout, authenticationState, error, accountInfo }: any) => {
                        switch (authenticationState) {
                            case AuthenticationState.Authenticated:
                                //console.log("AuthenticationState.Authenticated...");
                                if (accountInfo.account.idToken?.userRole){
                                    let userRoles = JSON.parse(accountInfo.account.idToken.userRole);
                                    //console.log(userRoles);
                                    // if (userRoles.indexOf('Admin') > -1){
                                    //     isAdmin = true;
                                    // }
                                }
                                // if (this.loginVerify === false) {
                                //     this.loginVerify = true;
                                //     this.props.verify(accountInfo.account);
                                // }
                                // if(this.props.userDB !== undefined && this.props.userDB.logged)
                                //     return this.render2(true, accountInfo.account, login, logout);
                                // else{
                                //     return <div>Loading Profile <Spinner color="warning"/></div>
                                // }
                                return this.render2(true, accountInfo.account, login, logout);
                                
                            case AuthenticationState.Unauthenticated:
                                console.log("AuthenticationState.Unauthenticated...");
                                // if (this.loginVerify === false) {
                                //     this.loginVerify = true;
                                //     this.props.logout();
                                // }
                                return (
                                    <div>
                                        {
                                            (error && error.errorMessage.search("AADB2C90091") ===0 &&(
                                                <RedirectHome login={login} />
                                            )) ||
                                            (error && error.errorMessage.search("AADB2C90118") ===0 &&(
                                                <HashRouter>
                                                    <Switch>
                                                     <Route component={ForgotPassword} />
                                                    </Switch>
                                                </HashRouter> 
                                                )) ||(
                                            error && (
                                                <div style={{ wordWrap: "break-word" }}>
                                                    <p>
                                                        Session expired, please login again...<br/>
                                                        <button onClick={login} className="btn btn-danger" >Login</button>
                                                    </p>
                                                    <p>Authentication fails, below is the errors that
                                                occured:</p>
                                                <p>
                                                        <span style={{ fontWeight: "bold" }}>Error Code:</span>{" "}
                                                        {error.errorCode}
                                                    </p>
                                                    <p>
                                                        <span style={{ fontWeight: "bold" }}>
                                                            Error Message:
                                                        </span>{" "}
                                                        {error.errorMessage}
                                                    </p>
                                                </div>
                                            )
                                                )
                                        }

                                        {
                                            //this.render2(false, undefined,login,logout);
                                        }
                                    </div>
                                );
                            case AuthenticationState.InProgress:
                                console.log("AuthenticationState.InProgress...");
                                return (this.render2(false, undefined,login,logout));
                        }
                    }
                }
            </AzureAD>
        )
    }

    render2(logged: any, user: any, login: any, logout?: any) {
        //const user = this.props.user;
        //if (!user.verified) { return(<div>Loading...</div>); }
        //
        return (
            <HashRouter>
            <Switch>
                {_.map(publicRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                        <Route
                            exact
                            path={path}
                            key={key}
                            render={(route) => <PublicLayout component={component} route={route} 
                            user={user}
                            logout={logout}
                            login={login}
                            logged={logged}
                            editProfile={this.editProfile.bind(this)} />}
                        />
                    )
                })}

                {_.map(privateRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                        <Route
                            exact
                            path={path}
                            key={key}
                            render={(route) =>
                                <PrivateLayout component={component} route={route} 
                                    user={user} 
                                    logout={logout}
                                    editProfile={this.editProfile.bind(this)} 
                                    login={login}
                                    logged={logged} />
                            }
                        />
                        // <Route
                        //     exact
                        //     path={path}
                        //     key={key}
                        //     render={(route) =>
                        //         logged ? (
                        //             <PrivateLayout component={component} route={route} 
                        //             user={user}
                        //             userDB = {this.props.userDB} logout={logout}
                        //             editProfile={this.editProfile.bind(this)} 
                        //             login={login}
                        //             logged={logged} />
                        //         ) : (
                        //                 <Redirect to="/" />
                        //                 //<PublicLayout component={Login} route={route} user={user}/>
                        //             )
                        //     }
                        // />
                    )
                })}

                {_.map(sessionRoutes, (route, key) => {
                    const { component, path } = route;
                    return (
                        <Route
                            exact
                            path={path}
                            key={key}
                            render={(route) =>
                                <SessionLayout 
                                    component={component} 
                                    route={route} 
                                    user={user} 
                                    logout={logout}
                                    editProfile={this.editProfile.bind(this)} 
                                    login={login}
                                    logged={logged}
                                    />
                            }
                        />
                        // <Route
                        //     exact
                        //     path={path}
                        //     key={key}
                        //     render={(route) =>
                        //         user.logged ? (
                        //             <Redirect to="/" />
                        //         ) : (
                        //                 <SessionLayout 
                        //                 component={component} 
                        //                 route={route} 
                        //                 user={user} 
                        //                 logout={logout}
                        //                 editProfile={this.editProfile.bind(this)} 
                        //                 login={login}
                        //                 logged={logged}

                        //                 />
                        //             )
                        //     }
                        // />
                    )
                })}

                <Route component={NotFound} />
            </Switch>
            </HashRouter> 
        );
    }
}

const mapStateToProps = (state: ApplicationState) => ({  userDB : state.userReducer })
const mapDispatchToProps = { verify: verifyAction, login: loginAction, logout: logoutAction }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Template);
